export default __webpack_public_path__ + "static/media/uncheck-box.144372aa.svg";